import { Release } from './Release';

export default Release;
